import { BiometryType } from '@aparajita/capacitor-biometric-auth';

const MINUTES_IN_IDLE_WINDOW = 5;
const SECONDS_IN_MINUTE = 60;
const MILLISECONDS_IN_SECOND = 1000;

export const BIOMETRIC_PROMPT = {
  REASON: 'Unlock to access your loans',
  CANCEL_TITLE: 'Cancel',
  IOS_FALLBACK_TITLE: 'Use passcode',
  ANDROID_TITLE: 'Biometric unlock',
  ANDROID_SUBTITLE: 'Confirm your identity to continue',
};

export const UNLOCK_RESULT = {
  GRANTED: 'granted',
  DENIED: 'denied',
  NO_SECURITY: 'noSecurity',
};

export const BIOMETRIC_IDLE_TIMEOUT_MS =
  MINUTES_IN_IDLE_WINDOW * SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND;

export const BIOMETRY_DISPLAY_NAME = {
  [BiometryType.faceId]: 'Face ID',
  [BiometryType.touchId]: 'Touch ID',
  [BiometryType.faceAuthentication]: 'face unlock',
  [BiometryType.fingerprintAuthentication]: 'fingerprint unlock',
  [BiometryType.irisAuthentication]: 'iris unlock',
};

export const BIOMETRY_DISPLAY_NAME_FALLBACK = 'biometric unlock';
